import { NOTIFICATION_LOADER, NOTIFICATION_DATA_RECEIVED } from './types';
import { notificationList } from '../apiHelpers/notification/list';

export const notificationListAction = params => async (dispatch, getState) => {
     if (getState().notification.notificationData == []) {
    dispatch({ type: NOTIFICATION_LOADER, payload: true });
     }
    const response = await notificationList(params);
    if (response.status === 'OK') {
        dispatch({ type: NOTIFICATION_DATA_RECEIVED, payload: response.data });
        dispatch({ type: NOTIFICATION_LOADER, payload: false });
    } else {
        dispatch({ type: NOTIFICATION_LOADER, payload: false });
    }
};



// WEBPACK FOOTER //
// ./src/actions/Notification.js